import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { provideProtractorTestingSupport, Title } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { httpInterceptor } from './modules/http-interceptor/http-interceptor';
import { routes } from './modules/routing/app-routing.module';
import { AppConfigService } from './services/app-config-service/app-config.service';
import { UrlConfigService } from './services/url-config-service/url-config.service';

export const appConfig = {
  providers: [
    AppConfigService,
    Title,
    CookieService,
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideAppInitializer(() => {
      const appConfigService: AppConfigService = inject(AppConfigService);
      return appConfigService.load();
    }),
    provideRouter(routes),
    provideProtractorTestingSupport(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, AppConfigService, UrlConfigService],
      },
    }),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: APP_BASE_HREF, useValue: '!' },
    { provide: Window, useValue: window },
  ],
};

export function HttpLoaderFactory(httpClient: HttpClient, appConfigService: AppConfigService, urlConfigService: UrlConfigService) {
  return new TranslateHttpLoader(httpClient, urlConfigService.getThemingServiceTranslationUrl(appConfigService.configurationId), '');
}
